<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="设备指令与日志" CMname="查询功能" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <!-- <el-form-item label="设备：" prop="planId">
                        <el-select v-model="searchform.planId" placeholder="请选择" >
                            <el-option
                                v-for="item in planIdData"
                                :key="item.planId"
                                :label="item.planName"
                                :value="item.planId">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                                <el-option label="媒体编号" value="lightBoxCode"></el-option>
                                <el-option label="媒体名称" value="lightBoxName"></el-option>
                                <el-option label="指令操作" value="orderContent"></el-option>
                                <el-option label="创建人" value="creationBy"></el-option>
                                <el-option label="批准人" value="approveBy"></el-option>
                                <el-option label="完成人" value="completeBy"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="创建时间：">
                        <el-date-picker v-model="searchform.startTime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="至">
                        <el-date-picker v-model="searchform.endTime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-select v-model="searchform.status" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="发送中" :value="0"></el-option>
                            <el-option label="已发送" :value="1"></el-option>
                            <el-option label="已完成" :value="2"></el-option>
                            <el-option label="异常" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onExport">导出Excel</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="IsRefresh" @change="Refreshchange()">自动刷新</el-checkbox>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="false">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="false">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="false">删除</el-button>
                    <el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="siteName" label="站点名称" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="lightBoxName" label="媒体名称" width="160" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="媒体编号" width="140" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140" fixed="left" sortable>
                    </el-table-column>
                    <el-table-column prop="deviceCode" label="自动设备编号" width="140" fixed="left" v-if="isHadFun('deviceCode')">
                    </el-table-column>
                    <el-table-column prop="orderContent" width="100" label="指令操作">
                    </el-table-column>
                    <el-table-column prop="content" width="300" label="指令内容">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="160" sortable>
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="80">
                    </el-table-column>
                    <el-table-column prop="approveDate" label="批准时间" width="160">
                    </el-table-column>
                    <el-table-column prop="approveBy" label="批准人" width="80">
                    </el-table-column>
                    <el-table-column prop="completeDate" label="完成时间" width="160">
                    </el-table-column>
                    <el-table-column prop="completeBy" label="完成人" width="80">
                    </el-table-column>
                    <el-table-column label="状态" width="100" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-tag type="danger" disable-transitions v-if="scope.row.status==0">发送中</el-tag>
                            <el-tag type="info" disable-transitions v-if="scope.row.status==1">已发送</el-tag>
                            <el-tag type="primary" disable-transitions v-if="scope.row.status==2">已完成</el-tag>
                            <el-tag type="success" disable-transitions v-if="scope.row.status==3">异常</el-tag>
                        </template>
                    </el-table-column>
                    <!--<el-table-column label="操作" width="80" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('Delete')">删除</el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
    </div>
</template>
<script>
export default {
    name: 'plan_open',
    data() {
        return {
            tab: "mycmd",
            searchform: {
                pageNum: 1,
                pageSize: 10,
                deviceNickCode: "",
                lightBoxCode:"",
                lightBoxName:"",
                startTime: null,
                endTime: null,
                orderContent: "",
                status: "",
                isLookCatch: "false",
                creationBy:"",
                approveBy:"",
                completeBy:""
            },
            myform: {
                cmd: ""
            },
            lightform: {
                time: "",
                percentage: 1
            },
            startform: {
                min: "",
                number: "02"
            },
            cmdform: {
                deviceCode: "",
                content: ""
            },
            tableData: [],
            planIdData: [],
            timeData: [],
            total: 0,
            IsRefresh: false,
            loading: true,
            selectionRows: [],
            selectfield: "deviceNickCode",
            keyword: "",
            dialogVisible: false,
            timeId: 0
        }
    },
    methods: {
        onSubmit() {
            this.searchform.deviceNickCode = "";
            this.searchform.lightBoxCode = "";
            this.searchform.lightBoxName = "";
            this.searchform.orderContent = "";
            this.searchform.creationBy = "";
            this.searchform.approveBy = "";
            this.searchform.completeBy = "";
            this.searchform.pageNum=1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.initData();
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
        },
        Rowdelete(val) {

            this.$confirm("确定要删除 '" + val.deviceNickCode + "' 设备的'" + val.content + "'指令么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios.post(this.$api.Order.del, { MN: val.deviceCode, PostTime: val.postTime })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios.post(this.$api.Order.del, { MN: myrow.deviceCode, PostTime: myrow.postTime });
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        Refreshchange() {
            var Vuethis = this;
            clearInterval(this.timeId);
            if (this.IsRefresh) {
                this.timeId = setInterval(function() { Vuethis.initData(); }, 2000);
            }
        },
        onExport() {
            this.$confirm("确定要导出Excel数据么？", { type: "warning" })
            .then(() => {
                var ExportURL = this.$api.Order.export;
                ExportURL = this.$hrraxios.defaults.baseURL + ExportURL;
                var params = this.$Qs.stringify(this.searchform, { indices: false });
                window.open(ExportURL + "?" + params);
            });

        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.Order.getorderlist, { params: this.searchform })
                //this.$hrraxios.get(this.$api.Order.getorderlist+"/"+this.searchform.pageNum+"/"+this.searchform.pageSize)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                    } else {
                        Vuethis.$message.error(data.Data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var now = new Date();
            now = now.setDate(now.getDate() - 1);
            now = new Date(now);
            this.searchform.startTime = now;
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.orderData = from.meta.orderData;
        next();
    },
    created() {
        if (this.$route.params.deviceCode) {
            this.searchform.status = parseInt(this.$route.params.status);
            this.searchform.deviceCode = this.$route.params.deviceCode;
        }
        this.$common.getFunListByMCode(this, "DeviceOrder", () => {
            this.searchform.isLookCatch = this.isHadFun('catch') ? "ture" : "false";
            this.initData();
            this.initParamsData();
        });
    }
}
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}
</style>